import React from 'react';

const Tools = () => {
  return <h1>Tools Page</h1>;
};

export default Tools;
